import React, { useEffect } from "react";
import styles from "../../styles/layout/Sidebar/manager-dashboard-sidebar.module.scss";
import { Box, List, ListItem, Typography } from "@mui/material";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import DashboardIcon from "../../public/assets/icons/DashboardIcon";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LogoutIcon from "../../public/assets/icons/LogoutIcon";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MenuSubmittedVideoIcon from "../../ui/Icons/MenuSubmittedVideoIcon";
import Iconpending from "../../public/assets/images/icon-pending.svg";
import Iconinquiring from "../../public/assets/images/icon-inquiring.svg";
import Iconapprove from "../../public/assets/images/icon-approve.svg";
import Iconwebsite from "../../public/assets/images/icon-website.svg";
import Iconduplication from "../../public/assets/images/icon-duplication.svg";
import Iconreject from "../../public/assets/images/icon-reject.svg";
import MenuReviewedVdoIcon from "../../ui/Icons/MenuReviewedVdoIcon";
import MenuVerifiedVdoIcon from "../../ui/Icons/MenuVerifiedVdoIcon";
import MenuNotificationIcon from "../../ui/Icons/MenuNotificationIcon";
import MenuAssignAcntIcon from "../../ui/Icons/MenuAssignAcntIcon";
import MenuMyMessageIcon from "../../ui/Icons/MenuMyMessageIcon";
import supportIcon from "../../public/assets/images/supportIcon.svg";
import MenuMyAcntIcon from "../../ui/Icons/MenuMyAcntIcon";
import RejectIcon from "../../public/assets/icons/RejectIcon";
import NotificationIcon from "../../public/assets/icons/NotificationIcon";
// import MessageIcon from "../../ui/Icons/MessageIcon";
import SubmenuMessageIcon from "../../public/assets/icons/SubmenuMessageIcon";
import SubmenuSupportIcon from "../../public/assets/icons/SubmenuSupportIcon";
import MyAccountIcon from "../../public/assets/icons/MyAccountIcon";
import InquiringIcon from "../../public/assets/icons/InquiringIcon";
import DuplicateIcon from "../../ui/Icons/DuplicateIcon";
import ApproveIcon from "../../public/assets/icons/ApproveIcon";
import WebsiteIcon from "../../public/assets/icons/WebsiteIcon";
import PendingPublicationIcon from "../../public/assets/icons/PendingPublicationIcon";
import MessageIcon from "../../public/assets/icons/MessageIcon";
import MenuVerifiedVdoBoldIcon from "../../ui/Icons/MenuVerifiedVdoBoldIcon";
import MenuReviewedVdoBoldIcon from "../../ui/Icons/MenuReviewedVdoBoldIcon";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { logout } from "../../redux-toolkit/slices/userSlice";

const MenuItem = [
  {
    path: "/manager-dashboard",
    name: "Dashboard",
    icon: (isactive) => <DashboardIcon active={isactive} />,
  },
  {
    name: "Submitted Videos",
    icon: (isactive) => <MenuSubmittedVideoIcon active={isactive} />,
    subitems: [
      {
        path: "/manager-dashboard/submitted-videos/pending",
        name: "Pending",
        icon: (isactive) => <PendingPublicationIcon active={isactive} />,
      },
      {
        path: "/manager-dashboard/submitted-videos/inquiring",
        name: "Inquiring",
        icon: (isactive) => <InquiringIcon active={isactive} />,
      },
      {
        path: "/manager-dashboard/submitted-videos/duplications",
        name: "Duplications",
        icon: (isactive) => <DuplicateIcon />,
      },
    ],
  },
  {
    name: "Reviewed Videos",
    icon: (isactive) => <MenuReviewedVdoIcon active={isactive} />,
    icon2: <MenuReviewedVdoBoldIcon />,
    subitems: [
      {
        path: "/manager-dashboard/reviewd-videos",
        name: "Approved",
        icon: (isactive) => <ApproveIcon />,
      },
      {
        path: "/manager-dashboard/reviewd-videos-website",
        name: "Website Only",
        icon: (isactive) => <WebsiteIcon />,
      },
      {
        path: "/manager-dashboard/reviewd-videos-rejected",
        name: "Rejected",
        icon: (isactive) => <RejectIcon />,
      },
    ],
  },
  {
    path: "/manager-dashboard/verified-videos-confirmed",
    name: "Verified Videos",
    icon: (isactive) => <MenuVerifiedVdoIcon active={isactive} />,
    icon2: <MenuVerifiedVdoBoldIcon />,
  },
  {
    path: "/manager-dashboard/notification",
    name: "Notifications",
    icon: (isactive) => <NotificationIcon active={isactive} />,
  },
  {
    path: "/manager-dashboard/assigned-accounts",
    name: "Assigned Accounts",
    icon: (isactive) => <MenuAssignAcntIcon active={isactive} />,
  },
  {
    name: "My Messages",
    icon: (isactive) => <MessageIcon active={isactive} />,
    subitems: [
      {
        path: "/manager-dashboard/messages",
        name: "Messages",
        icon: (isactive) => <SubmenuMessageIcon />,
      },
      {
        path: "/manager-dashboard/support",
        name: "Support",
        icon: (isactive) => <SubmenuSupportIcon />,
      },
    ],
  },
  {
    path: "/manager-dashboard/myaccount",
    name: "My Account",
    icon: (isactive) => <MyAccountIcon active={isactive} />,
  },
];
export const ManagerDashboardSidebar = () => {
  const dispatch = useAppDispatch();
  const logoutFunc = () => {
    dispatch(logout());
    // toastSuccess("Logout Successful");
  };
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const router = useLocation();
  const routePush = useNavigate();
  useEffect(() => {
    MenuItem.map((menu, index) => {
      let hasSubitems = menu.subitems && menu.subitems.length > 0;
      if (hasSubitems) {
        menu.subitems.map((item) => {
          if (item.path + router.hash === router.pathname + router.hash) {
            /* console.warn(item.path + router.hash, "-----Path");
                        console.warn(router.hash);
                        console.warn(
                            item.path + router.hash ===
                                router.pathname + router.hash
                        ); */
            setExpanded(menu.name);
          }
        });
      }
    });
  }, []);
  return (
    <Box className={styles.managerDashboardSidebar}>
      <Box className={styles.sideBar}>
        <PerfectScrollbar>
          <Box className={styles.menuList}>
            <List className={styles.outerUl}>
              {MenuItem.map((menu, index) => {
                let hasSubItems = menu.subitems && menu.subitems.length > 0;
                function checkSubItemActive() {
                  let active = false;
                  if (hasSubItems) {
                    menu.subitems.map((item) => {
                      if (item.path === router.pathname + router.hash) {
                        /* console.warn(
                                                    item.path + router.hash,
                                                    "-----Path"
                                                ); */
                        active = true;
                      }
                    });
                    return active;
                  }
                }
                const isSubItemActive = checkSubItemActive();
                // console.warn(isSubItemActive, "active????");
                return hasSubItems ? (
                  <ListItem
                    className={`${
                      isSubItemActive && styles.menuActive
                    } managerSidebar-${menu.name.split(" ")[0]}`}
                  >
                    <Box className={styles.menuItem}>
                      <Box className={styles.menuIcon}>
                        {/* {menu.icon(isSubItemActive)} */}
                        {isSubItemActive && menu.icon2
                          ? menu.icon2
                          : menu.icon(isSubItemActive)}
                      </Box>
                    </Box>
                    <Accordion
                      expanded={expanded === menu.name}
                      onChange={handleChange(menu.name)}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`${menu.name}bh-content`}
                        id={`${menu.name}bh-header`}
                      >
                        {menu.name}
                      </AccordionSummary>
                      <AccordionDetails>
                        <List disablePadding className={styles.submenuList}>
                          {menu.subitems.map((submenu, index) => (
                            <ListItem
                              key={index}
                              className={
                                submenu.path ===
                                  router.pathname + router.hash &&
                                styles.submenu_active
                              }
                            >
                              <Link to={submenu.path}>
                                {submenu.icon()}
                                <Typography variant="caption">
                                  {submenu.name}
                                </Typography>
                              </Link>
                            </ListItem>
                          ))}
                        </List>
                      </AccordionDetails>
                    </Accordion>
                  </ListItem>
                ) : (
                  <ListItem
                    className={`${
                      menu.path === router.pathname && styles.menuActive
                    } managerSidebar-${menu.name.split(" ")[0]}`}
                    key={index}
                  >
                    <Box className={styles.menuItem}>
                      <Link to={menu.path}>
                        <Box className={styles.menuIcon}>
                          {/* {menu.icon(menu.path === router.pathname)} */}
                          {menu.path === router.pathname && menu.icon2
                            ? menu.icon2
                            : menu.icon(menu.path === router.pathname)}
                        </Box>
                        <Typography variant="body1">{menu.name}</Typography>
                      </Link>
                    </Box>
                  </ListItem>
                );
              })}
              <ListItem className={styles.logoutIcon}>
                <Box className={styles.menuItem} onClick={logoutFunc}>
                  <Box className={styles.menuIcon}>
                    <LogoutIcon />
                  </Box>
                  <Typography variant="body1">Logout</Typography>
                </Box>
              </ListItem>
            </List>
          </Box>
        </PerfectScrollbar>
      </Box>
    </Box>
  );
};
